import { env } from '@skin-seoul/env-utils';
import qs from 'qs';

import axios, { AxiosInstance } from 'axios';

/**
 * you can use next cache with fetchOptions
 *
 * example:
 * const { data } = await client.get('/products', {
 *   fetchOptions: {
 *     next: {
 *       revalidate: 60,
 *     },
 *     cache: 'force-cache',
 *   },
 */

export const createSkinSeoulClient = (_baseURL?: string): AxiosInstance => {
  const baseURL = _baseURL ?? (env('NEXT_PUBLIC_ENV_SERVER_ORIGIN') || 'https://api.skin-seoul.com');

  // Debug logging for environment context
  const isServer = typeof window === 'undefined';
  const hasGlobalEnv = typeof globalThis !== 'undefined' && !!(globalThis as any).__ENV;

  console.debug('[service/client] Creating HTTP client:', {
    isServer,
    hasGlobalEnv,
    baseURL,
    envSource: hasGlobalEnv ? 'globalThis.__ENV' : 'process.env or fallback',
  });

  return axios.create({
    baseURL,
    withCredentials: true,
    adapter: 'fetch',
    paramsSerializer: (params) => qs.stringify(params, { indices: false }),
  });
};

export let client: AxiosInstance = createSkinSeoulClient();

export const setClient = (instance: AxiosInstance) => {
  client = instance;
};
